import { readServerChartPreference, writeServerChartPreference } from './chartPreferenceStore.js'

export function normalizeVwapAppearance(value = {}) {
  return {
    priceAxisVisible: value?.priceAxisVisible !== false,
    name: typeof value?.name === 'string' ? value.name.trim().slice(0, 60) : '',
    color: /^#[0-9a-f]{6}$/i.test(value?.color) ? value.color : null,
    // Absent metadata retains the legacy fixed color and width.
    ...(value?.colorMode === 'dynamic' || value?.colorMode === 'fixed' ? { colorMode: value.colorMode } : {}),
    ...(Object.hasOwn(value || {}, 'anchorPrice') ? { anchorPrice: Number.isFinite(value.anchorPrice) && value.anchorPrice > 0 ? value.anchorPrice : null } : {}),
    lineWidth: [1, 2, 3, 4].includes(value?.lineWidth) ? value.lineWidth : 2,
    opacity: Number.isFinite(value?.opacity) ? Math.max(0, Math.min(100, Math.round(value.opacity))) : 100,
    lineStyle: [0, 1, 2].includes(value?.lineStyle) ? value.lineStyle : 0,
  }
}
const identity = id => ({ scope: `anchored-vwap:${id}`, preferenceKey: 'appearance' })
export const retainedVwapAppearance = {
  async load(id) { return normalizeVwapAppearance(await readServerChartPreference(identity(id))) },
  async save(id, value) { return writeServerChartPreference({ ...identity(id), preferences: normalizeVwapAppearance(value) }) },
}
